module.exports = __webpack_public_path__ + "img/20_dice[18].b86d980a.png";